export enum CallStateEnum {
  IN_PROGRESS = 'IN_PROGRESS',
  CONNECTED = 'CONNECTED',
  FAILED = 'FAILED',
  ENDED = 'ENDED',
  MUTED = 'MUTED',
  ON_HOLD = 'ON_HOLD',
}
